import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-736fa8fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "file-drag-drop" }
const _hoisted_2 = { class: "paste-area" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drop-files" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-import" }),
  /*#__PURE__*/_createElementVNode("span", { class: "drop-files__label" }, " Drop files here")
], -1))
const _hoisted_5 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ReportList = _resolveComponent("ReportList")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["drag-and-drop", { 'drag-and-drop--uploading': $data.uploading }]),
      id: "upl-container"
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          ref: "fileform",
          onSubmit: _cache[9] || (_cache[9] = _withModifiers((...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
          class: _normalizeClass({ 'textarea-active': $data.textareaActive })
        }, [
          _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.textareaContent) = $event)),
              placeholder: "Add your ad-tag here...",
              ref: "textarea",
              onFocus: _cache[1] || (_cache[1] = $event => ($data.textareaActive = true)),
              onBlur: _cache[2] || (_cache[2] = $event => ($data.textareaActive = false)),
              autofocus: ""
            }, null, 544), [
              [_vModelText, $data.textareaContent]
            ]),
            _createElementVNode("button", {
              class: "upload-button",
              onClick: _cache[3] || (_cache[3] = (...args) => ($options.submitTag && $options.submitTag(...args))),
              disabled: $data.textareaContent === '',
              onHover: _cache[4] || (_cache[4] = $event => ($data.textareaActive = true)),
              onActive: _cache[5] || (_cache[5] = $event => ($data.textareaActive = true)),
              onFocus: _cache[6] || (_cache[6] = $event => ($data.textareaActive = true))
            }, " Upload tag ", 40, _hoisted_3)
          ]),
          _createElementVNode("div", {
            class: "drag-and-drop-area",
            onClick: _cache[8] || (_cache[8] = $event => (_ctx.$refs.file.click()))
          }, [
            _createElementVNode("input", {
              type: "file",
              ref: "file",
              multiple: "",
              style: {"display":"none"},
              onChange: _cache[7] || (_cache[7] = (...args) => ($options.fileDialogUpload && $options.fileDialogUpload(...args)))
            }, null, 544),
            _hoisted_4
          ])
        ], 34)
      ])
    ], 2),
    ($data.creativeData.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ReportList, { creativeData: $data.creativeData }, null, 8, ["creativeData"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}